import { createContext, useContext } from 'react';

export const CartContext = createContext();
export const useCartContext = () => {
  const context = useContext(CartContext);
  if (!context) {
    throw new Error(
      'CartContext compound components cannot be rendered outside the CartContext component',
    );
  }
  return context;
};
